import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { EquipmentDetails } from '../../manage-equipment/models/manage-equipment.model';
import { LoadingService } from '../../../shared/services/loading.service';
import { AppService } from '../../../app.service';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '../../../../app/translate';
import { TemperatureInspectionService } from '../temperature-inspection.service';
import { TemperatureInspectionListVM, TemperatureInspectionDetailVM, LoadInspectionListVM } from '../temperature-inspection.module';
import { MatDialog } from '@angular/material/dialog';import { AddTemInspectionCommentComponent } from '../add-tem-inspection-comment/add-tem-inspection-comment.component';
import { AddTempInspectionDetailsCommentComponent } from '../add-temp-inspection-details-comment/add-temp-inspection-details-comment.component';
import { ViewPhotoComponent } from '../../interpretation/components/view-photo/view-photo.component';
import { NotificationsService } from 'angular2-notifications';
import { UpdateAmbienttempInspectionDateDialogComponent } from '../update-ambienttemp-inspection-date-dialog/update-ambienttemp-inspection-date-dialog.component';
import { CreateNewTemperatureInspectionComponent } from '../create-new-temperature-inspection/create-new-temperature-inspection.component';

@Component({
  selector: 'app-interp-temperature-inspection',
  templateUrl: './interp-temperature-inspection.component.html',
  styleUrls: ['./interp-temperature-inspection.component.scss'],
  animations: [
    trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(25%)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateY(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
            ])
        ]
    )]
})
export class InterpTemperatureInspectionComponent implements OnInit {
  equipmentDetails: EquipmentDetails;
  equipmentId:number;
  inspectionId:number;

  nextInspectionDate:string
  isInspector:boolean=false;
  FamilyImage_Chain: string;
  FamilyImage_Frame: string;
  userLanguage = 'english';


  TemperatureInspectionList :TemperatureInspectionListVM[]=[];

  LeftInspectionList:TemperatureInspectionDetailVM[]=[];
  RightInspectionList:TemperatureInspectionDetailVM[]=[];


  loadmoreBefore:boolean=false;
  loadmoreRecent:boolean=false;
  showArrows:boolean=false;
  loadBefore:number=0;
  loadPrevious:number=0;
  loading:boolean;
  constructor(private _loading: LoadingService,
    private _app: AppService,
    private _equipmentService: ManageEquipmentService,
    private route: ActivatedRoute,
    private _userService: UserService,
    private _sanitizer: DomSanitizer,
    private _translate: TranslateService,
    private _ref: ChangeDetectorRef,
    private  _temperatureService: TemperatureInspectionService,private _dialog: MatDialog,
    private _notify: NotificationsService,) { }

  ngOnInit() {
    this._app.setPageTitle('Temperature Inspection');
    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.inspectionId = +this.route.snapshot.paramMap.get('id2');
    this.loadUserJobRoles();
    this.loadTemperatureInspection();

    if(this.equipmentId>0){
      this.loadEquipmentDetails();
    }
  }
LoadMoreInspections(){
 this.loading = true;
  var info = new LoadInspectionListVM();
  info.EquipmentId=this.equipmentId;
  info.InspectionId=this.inspectionId;
  info.LoadPrevious=this.loadmoreBefore;
  info.LoadRecent=this.loadmoreRecent;
  this._temperatureService.LoadTemperatureInspectionALLInspectionList(info).subscribe(res=>{
    this.TemperatureInspectionList = res;
    console.log("result", this.TemperatureInspectionList)
    this.loading=false;
  })
 
}
  LoadPrvious(){
    this.loadmoreBefore=true;
    this.LoadMoreInspections();
  }
  LoadRecent(){
    this.loadmoreRecent=true;
    this.LoadMoreInspections();
  }
  loadEquipmentDetails() {
    this._loading.startLoading();
    this._equipmentService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
        this.nextInspectionDate = equipment.NextInspectionDate;
        this.equipmentDetails = equipment;
        this.getFamilyDetails(this.equipmentDetails.Family);
        console.log("eq", this.equipmentDetails)
        this._loading.finishedLoading();
    });
}


CreateNewTemperatureInspection() {
  const newTemperatureInspectionDialog = this._dialog.open(CreateNewTemperatureInspectionComponent, {
      panelClass: 'removeModalOverflow',
      data: {
         
      },
      minWidth: 500
  });

  newTemperatureInspectionDialog.afterClosed().subscribe(result => {

      // if (result) {
      //     this.loadEquipmentDetails();
      // }
  });
}
viewInspectionPhoto(temperatureInspectionId: number,temperatureInspectionPhoto:string, isedit:boolean) {
  const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    data: {
      temperatureInspectionId : temperatureInspectionId,
      temperatureInspectionPhoto:temperatureInspectionPhoto,
      isedit:isedit
    }
  });
  viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
    if (reloadPhoto)
    //this.loadTemperatureInspection();
    this.LoadMoreInspections();
  });
}
viewInspectionDetailPhoto(temperatureInspectionDetailId: number,temperatureInspectionDetailPhoto:string,isedit:boolean)
{
  const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    data: {
      temperatureInspectionDetailId : temperatureInspectionDetailId,
      temperatureInspectionDetailPhoto:temperatureInspectionDetailPhoto,
      isedit:isedit
    }
  });
  viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
    if (reloadPhoto)
    //this.loadTemperatureInspection();
    this.LoadMoreInspections();
  });
}
getImage_(image: string) {
  if (image != null && image !== undefined)
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}
HasWarning(Id:number){
  let leftW= this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.WarningL;
  let RightW= this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.WarningL;
  if((leftW !=null) || (RightW !=null)){
    return true;
  }else{
    return false
  }
}
HasImage(Id:number){
  return this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.InspectionImage;
}
HasComment(Id:number){
  return this.TemperatureInspectionList.find(x=>x.InspectionSummary.InspectionID== Id).InspectionSummary.Note;
}
HasDetailComment(Id:number,InspectionDetailId:number,Side:number){
  if(Side==1){
    let com;
    this.TemperatureInspectionList.map(x=>{
      if(x.InspectionSummary.InspectionID == Id){
         com = x.LeftInspectionDetails.find(y=>y.InspectionDetailId == InspectionDetailId)
      }
     })

     if(com.Comment !=null){
       return true;
     }

  }else{
    let com;
    this.TemperatureInspectionList.map(x=>{
      if(x.InspectionSummary.InspectionID == Id){
         com = x.RightInspectionDetails.find(y=>y.InspectionDetailId == InspectionDetailId)
      }
     })

     if(com.Comment !=null){
       return true;
     }
    // this.TemperatureInspectionList.map(x=>{
    //   x.RightInspectionDetails.map(y=>{
    //     if(y.InspectionDetailId == Id){
    //       if(y.Comment!=null){

    //         return true;
    //       }
       
    //     }
    //   })
   // return  x.LeftInspectionDetails.find(y=>y.InspectionDetailId == Id).Comment;
    //})
   
  }
 
}

getWarning(Id:number){
  let warningL;
  let warningR;
  this.TemperatureInspectionList.map(x=>{
      if(x.InspectionSummary.InspectionID == Id){
         warningL = x.InspectionSummary.WarningL;
         warningR  = x.InspectionSummary.WarningR;
      }
  })
  let Final="";
    if(warningL !="" && warningR!="" ){
      return Final = 'LEFT' + '\n' + warningL + '\n' + 'RIGHT' + '\n'+ warningR ;
    }else if(warningL !="" && warningR==""){
      return Final = 'LEFT' + '\n' + warningL + '\n';
    }else if(warningL =="" && warningR!=""){
      return Final = 'RIGHT' + '\n' + warningR + '\n'; 
    }else
      return Final;
    }

CheckSelectedInspection(Id:number){
  if(Id==this.inspectionId){
    return true;
  }else{
    return false;
  }
}

IsMajor(outlier:boolean){
  if(outlier != true){
    return false
  }else{
    return true;
  }
}

IsMinor(outlier:boolean){
  if(outlier != false){
    return false
  }else{
    return true;
  }
}
getEval(val:boolean){
  if(val== true)
  return "major"
  if(val== false)
  return "minor"
  if(val== null)
  return "none"
}
loadTemperatureInspection(){
  this.loading=true;
  if(this.inspectionId>0 && this.equipmentId>0){
    console.log("Load selected inspection Id and two previous and two after inspections for the given equipment");
    this._temperatureService.LoadTemperatureInspection(this.equipmentId,this.inspectionId).subscribe(res=>{
        this.TemperatureInspectionList = res;
        console.log("result", this.TemperatureInspectionList)
        let leftSideLen = this.TemperatureInspectionList.length;
        if(leftSideLen>2){
          console.log("leftSideLen",leftSideLen)
          this.showArrows=true;
        }
        this.loading=false;
    }) 
  }else if(this.equipmentId>0 && (this.inspectionId==0 || this.inspectionId == undefined || this.inspectionId == null)){
    console.log("Need to laod recent 5 inspection for given equipment ");
    this._temperatureService.LoadTemperatureInspection(this.equipmentId,0).subscribe(res=>{
      this.TemperatureInspectionList = res;
      console.log("result", this.TemperatureInspectionList)
      let leftSideLen = this.TemperatureInspectionList.length;
      if(leftSideLen>2){
        this.showArrows=true;
      }
      this.loading=false;
  }) 

  }else{
    console.log("There is no equipment selected");
    this.CreateNewTemperatureInspection();
    this.loading=false;
  }
  
}

 /**
   * Updates a inspectiondetails temperature with the new temperature given.
   * Will reload the table with the data after saving successfully.
   * @param temperature The new temperature 
   * @param inspectionDetailId The inspection detail id to update the temperature for
   */
  public updateTemperatureValue(temperature: number, inspectionDetailId: number, InspectionId:number) {
    // const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, -1);
    this._temperatureService.updateInspectionDetailsTemperature(inspectionDetailId,temperature,InspectionId).subscribe(r => {
      if (r.m_Item1) {
        this.loadTemperatureInspection();
        //this.measurementPointUpdated.emit();
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update temperature. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update temperature. ');
      console.error(err);
    });
  }
loadUserJobRoles() {
  this._loading.startLoading();
  this._userService.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
          switch (r.Name) {
              case 'Inspectors':
                  this.isInspector = true;
                  break;
              case 'Interpreters':
                  this.isInspector = true;
                  break;
              case 'Super User':
              case 'Administrator':
                  this.isInspector = true;
                  break;
                  case 'Customer Admin':
                    this.isInspector = true;
                    break;
          }
      });

      this._loading.finishedLoading();
  });
}

getFamilyDetails(value: string) {
  this._equipmentService.getFamilyList().subscribe(result => {
      if (result != null) {
          const familydetails = result;
          familydetails.map(x => {
              if (x.typedesc === value) {
                  this.FamilyImage_Chain = x.ChainImage;
                  this.FamilyImage_Frame = x.FrameImage;
              }
          });
      }
  });
}

Translate(value: string): string {
  return this._translate.translateToLang(value, this.userLanguage);
}

getImage(image: string) {
  return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}

updateUserLang(lang: string) {
  this.userLanguage = lang;
  this._ref.detectChanges();
}
OpenDateAmbientChangeDialog(InspectionId:number,InspectionDate:Date, AmbientTemp:number){
  console.log()
  const newInspectionAmbientDialog = this._dialog.open(UpdateAmbienttempInspectionDateDialogComponent, {
    panelClass: 'removeModalOverflow',
    data: {
        AmbientTemp: AmbientTemp,
        InspectionId:InspectionId,
        InspectionDate:InspectionDate,
        EquipmentSetupDate:this.equipmentDetails.EquipmentSetupDate
    },
    minWidth: 500
});

newInspectionAmbientDialog.afterClosed().subscribe(result => {

    if (result) {
        //this.loadTemperatureInspection();
        this.LoadMoreInspections();
    }
});
}
//Open Inspection Comment
UpdateInspectionComment(InspectionId:number, comment:string, isedit:boolean){
  const newInspectionCommentDialog = this._dialog.open(AddTemInspectionCommentComponent, {
    panelClass: 'removeModalOverflow',
    data: {
        equipmentId: this.equipmentId,
        InspectionId:InspectionId,
        Inspcomment: comment,
        isedit:isedit
    },
    minWidth: 500
});

newInspectionCommentDialog.afterClosed().subscribe(result => {

    if (result) {
        //this.loadTemperatureInspection();
        this.LoadMoreInspections();
    }
});
}

UpdateInspectionDetailComment(InspectionDetailId:number, comment:string,isedit:boolean){
  const newInspectionDetailCommentDialog = this._dialog.open(AddTempInspectionDetailsCommentComponent, {
    panelClass: 'removeModalOverflow',
    data: {
        equipmentId: this.equipmentId,
        inspectionDetailID:InspectionDetailId,
        Inspcomment: comment,
        isedit:isedit
    },
    minWidth: 500
});

newInspectionDetailCommentDialog.afterClosed().subscribe(result => {

    if (result) {
        //this.loadTemperatureInspection();
        this.LoadMoreInspections();
    }
});
}

}
